import React, { useEffect, useRef } from 'react';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const TooltipTextPopupCustom = ({ 
  text, 
  truncateLength = 16, 
  placement = 'right',
  customClass = 'tooltip-primary',
  title = 'Details'
}) => {
  const triggerRef = useRef(null);
  const contentRef = useRef(null);
  const tooltipInstance = useRef(null); // Store in a ref

  const needsTooltip = text.length > truncateLength;

  useEffect(() => {
    if (needsTooltip && triggerRef.current && contentRef.current) {
      tooltipInstance.current = new Tooltip(triggerRef.current, {
        title: contentRef.current.innerHTML,
        trigger: 'hover',
        html: true,
        placement: placement,
        customClass: customClass
      });
    }

    return () => {
      if (tooltipInstance.current) {
        tooltipInstance.current.dispose();
        tooltipInstance.current = null;
      }
    };
  }, [text, placement, customClass, title, needsTooltip]);

  return (
    <>
      <span 
        ref={triggerRef}
        className={needsTooltip ? "tooltip-text-popup-trigger" : ""}
        data-bs-toggle={needsTooltip ? "tooltip" : undefined}
        style={{ cursor: needsTooltip ? 'pointer' : 'default' }}
      >
        {needsTooltip
          ? `${text.substring(0, truncateLength)}...`
          : text}
      </span>
      
      {needsTooltip && (
        <div 
          ref={contentRef} 
          className="my-tooltip tip-content hidden text-start shadow"
        >
          <p className="text-white">{text}</p>
        </div>
      )}
    </>
  );
};

export default TooltipTextPopupCustom;